import type { DirectorLanguage, LocalizedText } from './director-contracts.js';
import { formatClock } from './state.js';
import { TEAMS } from './teams.js';

/** Stable franchise labels. Player identities remain exactly as supplied by verified evidence. */
const CHINESE_TEAMS: Record<string, string> = {
  ATL: '老鹰', BOS: '凯尔特人', BKN: '篮网', CHA: '黄蜂', CHI: '公牛', CLE: '骑士',
  DAL: '独行侠', DEN: '掘金', DET: '活塞', GSW: '勇士', HOU: '火箭', IND: '步行者',
  LAC: '快船', LAL: '湖人', MEM: '灰熊', MIA: '热火', MIL: '雄鹿', MIN: '森林狼',
  NOP: '鹈鹕', NYK: '尼克斯', OKC: '雷霆', ORL: '魔术', PHI: '76人', PHX: '太阳',
  POR: '开拓者', SAC: '国王', SAS: '马刺', TOR: '猛龙', UTA: '爵士', WAS: '奇才',
};

/** Older stories may lack a translation. Never label another language as the requested one. */
export function directorText(text: LocalizedText, language: DirectorLanguage): string {
  const translated = text[language];
  if (typeof translated !== 'string') throw new Error(`Director translation unavailable: ${language}`);
  return translated;
}

export function directorTeamName(tricode: string, language: DirectorLanguage = 'en'): string {
  return (language === 'zh-Hans' ? CHINESE_TEAMS[tricode] : TEAMS[tricode]?.name)
    ?? tricode.replace(/[^A-Z]/g, '').slice(0, 3);
}

/** Preserve the source clock's fractional seconds, including overtime. */
export function directorClock(period: number, clockSec: number, language: DirectorLanguage = 'en'): string {
  const formatted = formatClock(period, clockSec);
  if (language !== 'zh-Hans') return formatted;
  const label = period <= 4 ? `第${period}节` : period === 5 ? '加时' : `第${period - 4}个加时`;
  return `${label} ${formatted.slice(formatted.indexOf(' ') + 1)}`;
}
